import { Link } from "react-router-dom";

export default function HomeHero() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20abstract%20geometric%20competition%20arena%20background%20with%20warm%20orange%20and%20amber%20gradient%20glowing%20particles%20floating%20upward%20dark%20atmospheric%20bottom%20silhouette%20of%20stadium%20crowd%20energetic%20modern%20esports%20gaming%20vibe%20cinematic%20lighting%20epic%20scale&width=1800&height=900&seq=17c-hero-bg&orientation=landscape"
        alt="17c每日大赛竞技舞台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-300/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            <span className="text-sm text-accent-200 font-medium">8月新赛季火热进行中</span>
          </div>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 mb-4 leading-tight">
            每天参赛
            <span className="text-accent-400">赢好礼</span>
          </h1>
          <p className="text-lg md:text-xl text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            17c每日大赛是专为你打造的每日竞技互动平台，每天开启全新赛事，轻松参赛、丰厚奖励等你来拿。加入我们，与万千玩家同台竞技，享受每日挑战乐趣！
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/jingji-saishi"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap"
            >
              立即参赛
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="px-8 py-3.5 rounded-full border-2 border-background-50/30 text-background-50 text-base font-semibold hover:bg-background-50/10 transition-all whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>

          <div className="mt-14 grid grid-cols-3 gap-6 max-w-2xl mx-auto">
            {[
              { value: "500万+", label: "注册用户" },
              { value: "100+", label: "每日赛事" },
              { value: "98%", label: "用户好评" },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.value}</div>
                <div className="text-sm text-background-50/60 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}